import { CurrenciesEffects } from '@app-shared/store/currencies/currencies.effects';
import { GuiParamsEffects } from '@app-shared/store/gui-params/gui-params.effects';
import { UserInfoEffects } from '@app-shared/store/user-info/user-info.effects';
import { CurrencyPairsEffects } from '@app-shared/store/currency-pairs/currency-pairs.effects';
import { BalancesEffects } from '@app/shared/store/balances/balances.effects';

export default [CurrencyPairsEffects, CurrenciesEffects, GuiParamsEffects, UserInfoEffects, BalancesEffects];
